import { render, staticRenderFns } from "./tenantPointForm.vue?vue&type=template&id=077ce63f&scoped=true"
import script from "./tenantPointForm.vue?vue&type=script&lang=js"
export * from "./tenantPointForm.vue?vue&type=script&lang=js"
import style0 from "./tenantPointForm.vue?vue&type=style&index=0&id=077ce63f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077ce63f",
  null
  
)

export default component.exports